import styles from './StateHeaderForm.module.scss';
import NewbannerFormTemplete from '@/components/organisms/NewBannerForm/NewbannerFormTemplete';
import CityListingBannerForm from '@/components/pages/CityListingPage/CityBannerForm';

export default function StateHeaderForm({
  associatedPrograms,
  rfiHeading,
  ctaButtonLabel,
  seatsFilled,
  showSeatsFilled = false,
  isStateHome=false,
  PROGRAM_ID
}: {
  associatedPrograms?: any;
  rfiHeading?: string;
  ctaButtonLabel?: string;
  seatsFilled?: string;
  showSeatsFilled?: boolean;
  isStateHome?:boolean
  PROGRAM_ID?: string;
}) {
  return (
    <div className={styles.formCard}> 
      <div className={styles.formInner}>
      {isStateHome ?
       <CityListingBannerForm isBanner={true}  RFIHeading={rfiHeading?? 'Book Your Free Counselling' }  associatedPrograms={associatedPrograms}  isSeatsFilledUI={false} />:
        <NewbannerFormTemplete
          associatedPrograms={associatedPrograms}
          RFIHeading={rfiHeading ?? 'Book Your Free Counselling'}
          sectionName="hero_banner"
          isStatsDisplay={false}
          ProgramId={PROGRAM_ID}
          isCityPage={true}
          BannerImageTemplete={showSeatsFilled && seatsFilled ? { SeatsFilled: seatsFilled } as any : undefined}
          className={styles.rfiRoot}
          ctaButtonLabel={ctaButtonLabel}
        />
      }
      </div>
    </div>
  );
}
